import { render } from "./servePeo.vue?vue&type=template&id=4a0b6f25&scoped=true&ts=true"
import script from "./servePeo.vue?vue&type=script&lang=ts"
export * from "./servePeo.vue?vue&type=script&lang=ts"

import "./servePeo.vue?vue&type=style&index=0&id=4a0b6f25&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0b6f25"]])

export default __exports__